<script setup lang="ts">
    import { useGlobalAuthCheck } from '@/composables/useGlobalAuthCheck';
    import AppContent from '@/components/AppContent.vue';
    import AppNavbar from '@/components/AppNavbar.vue';
    import AppShell from '@/components/AppShell.vue';
    import AppSidebar from '@/components/AppSidebar.vue';
    import AppSidebarHeader from '@/components/AppSidebarHeader.vue';
    import type { BreadcrumbItemType } from '@/types';
    import type { HTMLAttributes } from 'vue';

    withDefaults(
        defineProps<{
            breadcrumbs?: BreadcrumbItemType[];
            headerClass?: HTMLAttributes['class'];
            contentClass?: HTMLAttributes['class'];
            hideHeader?: boolean;
        }>(),
        {
            breadcrumbs: () => [],
            hideHeader: false,
        },
    );

    useGlobalAuthCheck();
</script>

<template>
    <AppShell variant="sidebar">
        <AppSidebar />
        <AppContent
            variant="sidebar"
            :class="contentClass"
        >
            <AppNavbar />
            <AppSidebarHeader
                v-if="!hideHeader"
                :breadcrumbs="breadcrumbs"
                :header-class="headerClass"
            >
                <template #actions>
                    <slot name="header-actions" />
                </template>
            </AppSidebarHeader>
            <slot />
        </AppContent>
    </AppShell>
</template>
